import {Paper, Typography } from '@mui/material';
import './ComingSoon.css';
export default function ComingSoon(){
  return (
    <Paper
      sx={{
        padding: "16px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "300px",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(144, 144, 144, 0.1)",
        my:3
      }}
    >
      <Typography variant="h3" fontWeight="bold" sx={{ color: "#555" }}>
        Coming Soon
      </Typography>
      <Typography sx={{ marginTop: "8px", color: "#777" }}>
        This feature is under development and will be available soon. Stay tuned!
      </Typography>
    </Paper>
  );
}